(() => {
  const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  const addBusinessDays = (date, days) => {
    const result = new Date(date);
    let remaining = days;
    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) remaining -= 1; // skip Sun/Sat
    }
    return result;
  };

  const formatDate = (date) => `${MONTHS[date.getMonth()]} ${date.getDate()}`;

  const init = (root) => {
    const nodes = root.querySelectorAll('[data-uf-delivery-estimate]');
    nodes.forEach((node) => {
      if (node.dataset.ufDeliveryReady === 'true') return;
      node.dataset.ufDeliveryReady = 'true';

      const maxDays = parseInt(node.dataset.maxDays, 10);
      const textEl = node.querySelector('[data-uf-delivery-estimate-text]');
      if (!textEl || !maxDays || Number.isNaN(maxDays)) return;

      const estimate = addBusinessDays(new Date(), maxDays);
      textEl.textContent = `Order today, get it by ${formatDate(estimate)}`;
    });
  };

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
